var map = {
	"./br/PT/S1/bg148.jpg": 95239,
	"./br/PT/bg148.jpg": 87867,
	"./in/EN/S1/bg148.jpg": 54722,
	"./ph/EN/S1/bg148.jpg": 42677,
	"./ph/EN/bg148.jpg": 79660,
	"./vn/VI/S1/bg148.jpg": 6485
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3069;